/* BCR cart drawer: keep the free-shipping progress bar in sync with the cart.
   Local re-renders the drawer form after every cart change, which re-creates
   its <shipping-notice>; we watch for that and refetch /cart.js. */
(function () {
  if (customElements.get('bcr-cart-bar')) return;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return (format || '${{amount}}').replace(/\{\{\s*amount(_with_comma_separator|_no_decimals)?\s*\}\}/, amount);
  }

  class BcrCartBar extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold || 0);
      this.format = this.dataset.moneyFormat || '${{amount}}';
      this.text = this.querySelector('.bcr-cart-bar__text');
      this.fill = this.querySelector('.bcr-cart-bar__fill');
      var drawer = this.closest('sidebar-drawer') || document;
      var self = this;
      // React only when Local re-renders the cart, not to this bar's own text
      // updates: those would refetch /cart.js and re-render in an endless loop.
      this.observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (!self.contains(records[i].target)) return self.scheduleRefresh();
        }
      });
      this.observer.observe(drawer, { childList: true, subtree: true });
      document.addEventListener('cart:updated', this.scheduleRefresh.bind(this));
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
    scheduleRefresh() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.refresh.bind(this), 250);
    }
    refresh() {
      var self = this;
      fetch(window.KROWN && KROWN.settings.routes.cart_url ? KROWN.settings.routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart.total_price || 0); })
        .catch(function () {});
    }
    render(total) {
      if (!this.threshold) return;
      var remaining = Math.max(this.threshold - total, 0);
      var pct = Math.min(Math.round((total / this.threshold) * 100), 100);
      if (this.fill) this.fill.style.width = pct + '%';
      if (this.text) {
        var label = remaining === 0
          ? "You've unlocked free shipping"
          : formatMoney(remaining, this.format) + ' more for free shipping';
        if (this.text.textContent !== label) this.text.textContent = label;
      }
      this.classList.toggle('bcr-cart-bar--done', remaining === 0);
    }
  }
  customElements.define('bcr-cart-bar', BcrCartBar);
})();
